import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../../services/api";
import { normalizedCategories } from "../../utils/auxFunc";

const ProductsContext = createContext();
export const useProducts = () => useContext(ProductsContext);

export const ProductsContextProvider = ({ children }) => {
	const [categories, setCategories] = useState(null);
	const [dolarValue, setDolarValue] = useState();

	const getCategories = async () => {
		api.categories
			.listAll()
			.then((response) => response.json())
			.then((categories) => {
				const allCategories = normalizedCategories(categories);
				setCategories(allCategories);
			})
			.catch((error) => {
				console.log("Error al obtener categorías: ", error.message);
			});
	};

	const getDolarvalue = () => {
		api.products
			.dolarValue()
			.then((response) => response.json())
			.then((dolarValue) => {
				setDolarValue(dolarValue.dolarValue);
			})
			.catch((error) => {
				console.log(
					"Error al obtener el valor actual del dolar: ",
					error.message
				);
			});
	};

	useEffect(() => {
		getCategories();
		getDolarvalue();
	}, []);

	return (
		<ProductsContext.Provider value={{ categories, dolarValue }}>
			{children}
		</ProductsContext.Provider>
	);
};

export default ProductsContext;
